import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineShoppingCart,
  AiOutlineUser,
  AiOutlineBgColors,AiOutlineLogout
} from "react-icons/ai";
import { RiCouponLine } from "react-icons/ri";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { ImBlog } from "react-icons/im";
import { IoIosNotifications } from "react-icons/io";
import { FaClipboardList, FaBloggerB } from "react-icons/fa";
import { SiGoogleearthengine } from "react-icons/si";
 
import { SiBrandfolder } from "react-icons/si";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
 import { useDispatch, useSelector } from "react-redux";
import logo from "../images/car-logo.png"
import { FaCar } from "react-icons/fa";
 import { MdQuestionAnswer } from "react-icons/md";
import { BsFillSendFill } from "react-icons/bs";

const { Header, Sider, Content } = Layout;


const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();


 
   const unreadBookingsCount = useSelector(state => state?.booking?.bookings?.filter(b => !b.read)?.length || 0);
  const unreadEnquiriesCount = useSelector(state => state?.enquiry?.enquiries?.filter(e => !e.read)?.length || 0);
  
  // Calculate the total unread count
  const totalUnreadCount =    unreadBookingsCount + unreadEnquiriesCount;
  console.log(totalUnreadCount,"unread")
  const {
    token: { colorBgContainer },
  } = theme.useToken();

 
  const getTokenFromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

const config3 = {
  headers: {
    Authorization: `Bearer ${
      getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
    }`,
    Accept: "application/json",
  },
};

 
  

   


  
  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">M.T.M</span>
            <span className="lg-logo">Matel Trading Motors</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          className="menu-wrapper"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              localStorage.clear()
              window.location.reload()
            } else {
              navigate(key);
            }
          }}
          items={[
     
            {
              key: "Catalog",
              icon: <FaCar className="fs-4" />,
              label: "Catalog",
              children: [
                {
                  key: "vehicle",
                  icon: <FaCar className="fs-4" />,
                  label: "Add Car",
                },
                {
                  key: "list-vehicle",
                  icon: <FaCar className="fs-4" />,
                  label: "Car List",
                },
                {
                  key: "brand",
                  icon: <SiBrandfolder className="fs-4" />,
                  label: "Brand",
                },
                {
                  key: "list-brand",
                  icon: <SiBrandfolder className="fs-4" />,
                  label: "Brand List ",
                },


                {
                  key: "brandModel",
                  icon: <SiBrandfolder className="fs-4" />,
                  label: "Brand Model",
                },
                {
                  key: "list-brand-model",
                  icon: <SiBrandfolder className="fs-4" />,
                  label: "Brand Model List ",
                },

       


 
         

                {
                  key: "engine-size",
                  icon: <SiGoogleearthengine className="fs-4" />,
                  label: "Engine Size",
                },
                {
                  key: "engine-size-list",
                  icon: <SiGoogleearthengine className="fs-4" />,
                  label: "Engine Size List ",
                },
    

              ],
            },
 
        
       
            {
              key: "enquiries",
              icon: (
                <div className="position-relative">
                  <MdQuestionAnswer className="fs-4" />
                  {unreadEnquiriesCount > 0 && (
                    <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>
                  )}
                </div>
              ),
              label: "Enquiries",
            },
              {
                  key: "blogs",
                  icon: <FaBloggerB className="fs-4" />,
                  label: "Blogs",
                  children: [
                    {
                      key: "blog",
                      icon: <ImBlog className="fs-4" />,
                      label: "Add Blog",
                    },
                    {
                      key: "blog-list",
                      icon: <FaBloggerB className="fs-4" />,
                      label: "Blog List",
                    },
             
                  ],
                },           
            {
              key: "bookings",
              icon: (
                <div className="position-relative">
                  <FaClipboardList className="fs-4" />
                  {unreadBookingsCount > 0 && (
                    <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>
                  )}
                </div>
              ),
              label: "Bookings",
            },
             {
              key: "subscribers",
              icon: (
                <div className="position-relative">
                  <BsFillSendFill className="subscriber-icon" />
                
                </div>
              ),
              label: "Subscribers",
            },           

            {
              key: "signout",
              icon: <AiOutlineLogout className="fs-4" />,
              label: "Sign Out",
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
          <div className="position-relative"  >
          <IoIosNotifications className="fs-4" />
          {totalUnreadCount > 0 && (
        <span className="badge bg-warning rounded-circle p-1 position-absolute" style={{ zIndex: 1 }}>
          {totalUnreadCount}
        </span>
      )}
             </div>

            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
                <img
                  width={32}
                  height={32}
                  src={logo}
                  alt=""
                />
              </div>
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5 className="mb-0">Matel Trading Motors  </h5>
                <p className="mb-0">Info@mateltradingmotors.com</p>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
